import { InputWrapper } from "./input-wrapper";
import { Error } from "./error";
import type { FormErrors } from "@repo/shared-types";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label?: string;
  description?: React.ReactNode;
  preffix?: React.ReactNode;
  errors?: FormErrors;
  rows?: number;
  inputRef?: React.RefObject<HTMLInputElement | HTMLTextAreaElement | null>;
}

export function Input({
  label,
  className = "",
  errors,
  preffix,
  description,
  inputRef,
  ...props
}: InputProps) {
  const showError = errors?.[props.name ?? ""];
  const inputProps = {
    className: `w-full outline-none ${className}`,
    autoComplete: "off",
    ...props,
  };

  if (inputProps.autoComplete === "off") {
    (inputProps as any)["data-1p-ignore"] = true;
  }

  return (
    <div className="flex flex-col gap-1 w-full">
      <InputWrapper
        label={label}
        description={description}
        hasError={!!showError}
      >
        {preffix && (
          <span className="text-sm text-gray-700 border-r border-gray-200 pr-2 mr-2 whitespace-nowrap">
            {preffix}
          </span>
        )}
        {props.type === "textarea" ? (
          <textarea
            ref={inputRef as React.RefObject<HTMLTextAreaElement>}
            {...inputProps}
          />
        ) : (
          <input
            ref={inputRef as React.RefObject<HTMLInputElement>}
            {...inputProps}
          />
        )}
      </InputWrapper>
      {showError && <Error fieldName={props.name} errors={errors} />}
    </div>
  );
}
